import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DeletePlanModal({ isOpen, onClose, onConfirm, saving }) {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) setValue('');
  }, [isOpen]);

  const isValid = useMemo(() => {
    const s = String(value || '').trim().toUpperCase();
    return s === 'DELETE' || s === 'SUPPRIMER';
  }, [value]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-5 border-b border-gray-100 flex justify-between items-center">
          <div className="text-lg font-extrabold text-gray-900">{t('plan.delete.title')}</div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-700 font-bold">
            ✕
          </button>
        </div>

        <div className="p-5">
          <div className="text-sm text-gray-700 font-semibold">
            {t('plan.delete.warning')}
          </div>
          <div className="mt-3 text-sm text-gray-700">
            {t('plan.delete.type_hint')}
          </div>

          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="mt-3 w-full px-3 py-2 rounded-lg border border-gray-200 text-sm font-bold uppercase tracking-wide"
            placeholder={t('plan.delete.placeholder')}
            autoFocus
            disabled={!!saving}
          />

          <div className="mt-2 text-[11px] text-gray-500 font-semibold">
            {t('plan.delete.accepted')}
          </div>
        </div>

        <div className="p-5 border-t border-gray-100 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={!!saving}
            className={[
              'px-4 py-2 rounded-lg font-bold',
              saving ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100'
            ].join(' ')}
          >
            {t('workout.cancel')}
          </button>
          <button
            type="button"
            disabled={!isValid || !!saving}
            onClick={() => onConfirm?.()}
            className={[
              'px-4 py-2 rounded-lg font-extrabold text-white',
              !isValid || saving ? 'bg-red-300 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
            ].join(' ')}
          >
            {saving ? t('plan.delete.deleting') : t('plan.delete.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}


